import React from 'react';
import { ReactComponent as MySvg } from '../../assets/icons/organise-home-screen-nav-icon.svg';

type Props = {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
};

const OrganiseHomeScreenIcon: React.FC<Props> = ({
  width = 24,
  height = 21,
  className,
  style,
}) => {
  return (
    <MySvg
      width={width}
      height={height}
      className={className}
      style={{ color: '#555555' }}
    />
  );
};

export default OrganiseHomeScreenIcon;